import I18n from 'i18n-js';

const ISO = /^(\d{4}-\d{2}-\d{2})[T ](\d{2}):(\d{2})(?::\d{2})?(?:\.\d+)?(Z|[+-]\d{2}:?\d{2})?/;
const FALLBACK_DATE = '2000-01-01';
// No offset means the server reads the time in its own zone, as the legacy webclient's naive
// "YYYY-MM-DD HH:MM" strings do; a null column must not be saved as UTC.
const FALLBACK_OFFSET = '';
const pad = number => String(number).padStart(2, '0');

const parts = iso => {
  const match = typeof iso === 'string' ? ISO.exec(iso) : null;
  return match
    ? {
        date: match[1],
        hours: Number(match[2]),
        minutes: Number(match[3]),
        offset: match[4] || FALLBACK_OFFSET
      }
    : {
        date: FALLBACK_DATE,
        hours: 0,
        minutes: 0,
        offset: FALLBACK_OFFSET
      };
};

// The server answers in its own zone (e.g. "-04:00") and the admin edits those digits, so the edit
// keeps that offset; rewriting it to "Z" shifted the saved time (GROOV-5187 review Blocker #1).
export const withTime = (iso, hours, minutes) =>
  `${parts(iso).date}T${pad(hours)}:${pad(minutes)}:00.000${parts(iso).offset}`;

export const clockText = iso => {
  const {hours, minutes} = parts(iso);
  return `${pad(hours)}:${pad(minutes)}`;
};

export const parseClock = text => {
  const match = /^([01]?\d|2[0-3]):([0-5]\d)$/.exec(String(text).trim());
  return match ? {hours: Number(match[1]), minutes: Number(match[2])} : null;
};

export const rangeEndHour = iso => {
  const {hours, minutes} = parts(iso);
  return hours === 23 && minutes === 59 ? 24 : hours;
};

export const rangeStartHour = iso => parts(iso).hours;

export const withRangeHour = (iso, hour) =>
  hour === 24 ? withTime(iso, 23, 59) : withTime(iso, hour, 0);

export const hourLabel = hour => {
  if (hour === 24) return I18n.t('tenantSettings.hourEndOfDay');
  const clock = hour % 24;
  const suffix =
    clock < 12
      ? I18n.t('tenantSettings.hourAm')
      : I18n.t('tenantSettings.hourPm');
  const twelve = clock % 12 === 0 ? 12 : clock % 12;
  return `${twelve}:00 ${suffix}`;
};
